import { z } from "zod";

export const VehicleSchema = z.object({
  id: z.string(),
  brand: z.string(),
  model: z.string(),
  year: z.number(),
  trim: z.string().optional().nullable(),
  mileage: z.number(),
  vin: z.string().optional().nullable(),
  nickname: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
  image_url: z.string().optional().nullable(),
  wd_id: z.string().optional().nullable(),
  is_primary: z.boolean().optional(),
  health_score: z.number().optional(),
  engine: z.string().optional().nullable(),
  fuel: z.string().optional().nullable(),
  transmission: z.string().optional().nullable(),
  warranty: z.string().optional().nullable(),
  vin_facts: z.record(z.any()).optional().nullable(),
});

export const HealthSchema = z.object({
  score: z.number(),
  grade: z.string(),
  systems: z.record(
    z.object({
      score: z.number(),
      status: z.string(),
      note: z.string(),
    }),
  ),
  summary: z.string().optional(),
  recalls_count: z.number().optional(),
});

export const AgentIntentSchema = z.enum([
  "diagnosis",
  "maintenance",
  "recall",
  "parts",
  "shop",
  "booking",
  "repair",
  "emergency",
  "vision",
  "report",
  "health",
]);

export function displayVehicleName(v) {
  if (!v) return "Vehicle";
  if (v.nickname) return v.nickname;
  return `${v.year || ""} ${v.brand || ""} ${v.model || ""}`.trim();
}
